import React, { useState } from 'react'
import ReactDOM from 'react-dom'
// import ReactDOM from 'react-dom'
import { compose } from 'recompose'
// import Script from 'react-load-script'
import { Button, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
// import _entries from 'lodash/entries'
import QRCode from 'qrcode'
// import JsBarcode from 'jsbarcode/src/barcodes/CODE128/CODE128'
import JsBarcode from 'jsbarcode'
import ThaiBath from 'thai-baht-text'
// import moment from 'moment'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'
// import TransferModal from './TransferModal'
import { Block } from '../styles'

// import { inject, observer } from 'mobx-react'

const SlipPart = ({ ref1, ref2, customer, amount, title, barcode, qrCode }) => (
  <div className="section">
    <div style={{ display: 'flex', width: '100%' }}>
      <div className="bold" style={{ width: '60%' }}>
        ใบนำฝากชำระเงินค่าสินค้าหรือบริการ (Bill Payment Pay-In Slip)
      </div>
      <div className="bold" style={{ width: '40%', textAlign: 'end' }}>
        <span className="box" style={{ display: 'inline-block' }}>{title}</span><br />
        โปรดเรียกเก็บค่าธรรมเนียมจากผู้ชำระเงิน*
      </div>
    </div>
    <div style={{ display: 'flex', marginTop: '5mm', width: '100%' }}>
      <div style={{ display: 'flex', width: '60%', justifyContent: 'center' }}>
        <div style={{ fontSize: '10px', width: '50%', textAlign: 'center' }}>
          <img src={process.env.REACT_APP_BASE_URI + '/logo.png'} alt="ThaiRun" />
          <br />
          เลขประจำตัวผู้เสียภาษี : 0105560034567
        </div>
        <div className="small" style={{ width: '50%' }} >
          บริษัท ไทยดอทรัน จำกัด<br />
          791 โครงการ Stadium one ถนนพระราม 6<br />
          แขวงวังใหม่ เขตปทุมวัน กรุงเทพ 10330<br />
          โทรศัพท์ 02-1634-554
        </div>
      </div>
      <div style={{ width: '40%', textAlign: 'center' }}>
        สาขา/Branch .................... วันที่/Date ....................<br />
        <div style={{ width: '90%', border: '1px solid #000000', padding: '10px' }}>
          ชื่อ/Name {customer.firstName} {customer.lastName} <br />
          Ref.1/Ref.1 {ref1} <br />
          Ref.2/Ref.2 {ref2} <br />
        </div>
      </div>
    </div>
    <div style={{ margin: '1em 0' }}>
      เพื่อนำเข้าบัญชี บริษัท ไทยดอทรัน จำกัด
    </div>
    <div>
      <span style={{
        width: '1em',
        height: '1em',
        border: '2px solid black',
        display: 'inline-block',
        verticalAlign: 'top',
        marginRight: '6pt',
        boxSizing: 'border-box'
      }} />
      <span style={{ display: 'inline-block', fontSize: '9pt' }}>
        ธนาคารอื่นๆ ที่รับชำระบิล Biller ID : 010556003456700
        <img style={{ width: '250px', verticalAlign: 'middle', margin: '0 6pt' }} src="https://storage.googleapis.com/assets.thai.run/race/payment.png" alt="payment" />
        รับชำระด้วยเงินสดเท่านั้น <br />
        <span className="small">(ค่าธรรมเนียมไม่เกิน 5 บาท/รายการในช่องทางอิเล็กทรอนิคส์ และไม่เกิน 20 บาท/รายการในช่องทางสาขา)</span>
      </span>
    </div>
    <div style={{ marginTop: '20px' }}>
      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>รับเฉพาะเงินสดเท่านั้น</th>
            <th>จำนวนเงิน (บาท)/Amount (Baht)</th>
            <th>{amount}</th>
            <th>สำหรับเจ้าหน้าที่</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>จำนวนเงินเป็นตัวอักษร/Amount in Words</td>
            <td colSpan="2">{ThaiBath(amount)}</td>
            <td>ผู้รับเงิน ..........</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px', width: '100%' }}>
      <div className="small" style={{ width: '30%', paddingLeft: '20px' }}>
          ชื่อผู้นำฝาก/Deposit by {customer.firstName} {customer.lastName} <br />
          โทรศัพท์/Telephone {customer.telephone}
      </div>
      <div className="small" style={{ width: '70%', justifyContent: 'center' }}>
          หมายเหตุ<br />
          - ท่านสามารถตรวจสอบรายชื่อธนาคารและผู้ให้บริการที่เข้าร่วมได้จากเว็บไซต์ของธนาคารแห่งประเทศไทย <br />
          - ค่าธรรมเนียมเป็นเงื่อนไขและข้อกำหนดของแต่ละธนาคาร/ผู้ให้บริการ
      </div>
    </div>
    {barcode && (
      <img style={{ position: 'absolute', bottom: '5mm', left: '5mm', width: '90mm' }} src={barcode} alt="Barcode" />
    )}
    {qrCode && (
      <img style={{ position: 'absolute', bottom: '5mm', right: '5mm', width: '20mm' }} src={qrCode} alt="QR Code" />
    )}
  </div>
)

const showSlip = ($slip) => {
  const w = window.open()
  const root = w.document.createElement('div')
  w.document.body.appendChild(root)
  ReactDOM.render($slip, root)
  // w.print()
  // w.addEventListener('load', function () {
  //   w.print()
  // }, true)
  w.setTimeout(() => {
    w.focus()
    w.print()
    // w.close()
  }, 1000)
}

const ScbSlip = compose(
  // inject('i18n'),
  injectIntl,
  graphql(payRegistrationMutation, {
    name: 'payRegistration'
  })
  // observer
)(({ intl, registration, payRegistration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted, bankAccountInfo }) => {
  // const totalAmount = discounted + itemsDiscounted
  // const fee = Math.round(gatewayRate * discounted * 100) / 100
  const [paymentLoading, setPaymentLoading] = useState(false)

  const handleCheckout = async () => {
    setPaymentLoading(true)
    try {
      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'scb_slip',
            data: {
              scb: {
                completeRedirect: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
              }
            }
          }
        }
      })
      const payAmount = _get(
        data,
        'payRegistration.record.payAmount'
      )
      const source = _get(
        data,
        'payRegistration.record.data.scb.invoice.source'
      )
      const ref1 = _get(
        data,
        'payRegistration.record.data.scb.invoice.ref1'
      )
      const ref2 = _get(
        data,
        'payRegistration.record.data.scb.invoice.ref2'
      )
      const customer = _get(
        data,
        'payRegistration.record.data.scb.invoice.customer'
      )
      // console.log(source, source.split('\r'))
      if (source) {
        console.log({ x: JSON.stringify(source) }, source.length)
        const qrCode = await QRCode.toDataURL(source, { scale: 8 })
        const canvas = document.createElement('canvas')
        JsBarcode(canvas, source, {})
        // console.log({ d })
        const barcode = canvas.toDataURL()
        // const barCode = await QRCode.toDataURL(source, { scale: 8 })
        // const $slip
        const $slip = <React.Fragment>
          <style dangerouslySetInnerHTML={{ __html: `
            body {
              box-sizing: border-box;
              width: 210mm;
              height: 295mm;
              margin: auto; 
              padding: 5mm;
              font-size: 10pt;
            } 
            .section {
              box-sizing: border-box;
              height: 140mm;
              border: 1px solid black;
              padding: 5mm;
            }
            .section + .section {
              margin-top: 5mm;
              position: relative;
            }
            .box {
              padding: 2mm;
              border: 1px solid black;
            }
            .small {
              font-size: 8pt;
            }
            .bold {
              font-weight: bold;
            }

            table, th, td {
              border: 1px solid black;
              border-collapse: collapse;
              font-size: 12px;
            }
            th, td {
              padding: 5px;
              text-align: left;    
            }`}} />
          <SlipPart title="สำหรับลูกค้า" ref1={ref1} ref2={ref2} amount={payAmount} customer={customer} />
          <SlipPart title="สำหรับธนาคาร" ref1={ref1} ref2={ref2} amount={payAmount} customer={customer} barcode={barcode} qrCode={qrCode} />
        </React.Fragment>
        showSlip($slip)
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      setPaymentLoading(false)
    }
  }

  return <Block>
    <div className="title">
      <FormattedMessage id="paymentMethod.scb_slip" />
    </div>
    <FormattedMessage id="paymentMethod.scb_slip.info" />
    <div>
      {systemFee
        ? <React.Fragment>
          <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted - totalSystemFee)
          }} />
          <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(totalSystemFee)
          }} />
        </React.Fragment>
        : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(discounted)
        }} />
      }
      {/* <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
        amount: intl.formatNumber(fee)
      }} /> */}
      {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
        amount: intl.formatNumber(itemsDiscounted)
      }} />}
    </div>
    <div>
      <div>
        <FormattedMessage id="app.processingFeeBank" defaultMessage="Processing Fee" />
      </div>
    </div>
    <Button
      icon="barcode"
      type="primary"
      onClick={() => handleCheckout()}
      loading={paymentLoading}
      className="paymentButton"
    >
      <FormattedMessage id="paymentMethod.scb_slip.print" />
    </Button>
  </Block>
})

export default ScbSlip



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/ScbSlip/ScbSlip.js